import styled from '@emotion/styled';

export const CardGrid = styled.div<{ disabled?: boolean }>`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 0;
  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}
`;

export const Card = styled.div<{ dimmed?: boolean }>`
  position: relative;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  cursor: pointer;
  transition:
    box-shadow 0.2s,
    transform 0.2s;
  opacity: ${({ dimmed }) => (dimmed ? 0.65 : 1)};

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
`;

export const CardThumbnail = styled.div`
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  overflow: hidden;
  position: relative;
`;

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const CardBody = styled.div`
  padding: 16px;
`;

export const CardTitle = styled.h3`
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const TagRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 10px;
`;

export const Tag = styled.span<{ variant: 'strategy' | 'static' | 'video' }>`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;

  ${({ variant }) => {
    switch (variant) {
      case 'strategy':
        return 'background: #e0e7ff; color: #4338ca;';
      case 'static':
        return 'background: #f0e6ff; color: #7c3aed;';
      case 'video':
        return 'background: linear-gradient(135deg, #3b82f6, #1d4ed8); color: #fff;';
      default:
        return 'background: #e0e7ff; color: #4338ca;';
    }
  }}
`;

export const CardDescription = styled.p`
  margin: 12px 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const InfoLines = styled.div`
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const InfoLine = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
`;

export const InfoLabel = styled.span`
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  color: #999;
  min-width: 55px;
`;

export const InfoValue = styled.span`
  font-size: 12px;
  color: #333;
`;

export const VisibilityCheckboxWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(255, 255, 255, 0.92);
  padding: 4px 8px;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
`;

export const VisibilityCheckbox = styled.input`
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
  accent-color: #16a34a;
`;

export const VisibilityLabel = styled.label`
  font-size: 11px;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  user-select: none;
`;

export const HiddenBadge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  background: #fef2f2;
  color: #dc2626;
  letter-spacing: 0.5px;
`;

export const VisibleBadge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  background: #f0fdf4;
  color: #16a34a;
  letter-spacing: 0.5px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;
  color: #999;
`;

export const EmptyStateTitle = styled.h3`
  margin: 16px 0 8px;
  font-size: 18px;
  font-weight: 600;
  color: #555;
`;

export const EmptyStateText = styled.p`
  font-size: 14px;
  color: #999;
  margin: 0;
`;
